/* ── Global Table Design — Monday.com style (v11.05) ── */
export const globalTableCSS = `
  /* ══ BLITZ TABLE SYSTEM — Monday.com inspired ══
     Clean white bg · Full cell borders · Sharp readable text
  ══════════════════════════════════════════════════════ */

  /* Light mode: all tables get Monday.com treatment */
  :not(.dark-mode) table {
    border-collapse: collapse !important;
    font-family: 'Plus Jakarta Sans', 'Inter', 'Segoe UI', sans-serif !important;
    -webkit-font-smoothing: antialiased;
    border: 1px solid #E5E7EB !important;
    border-radius: 8px !important;
    overflow: hidden !important;
  }

  /* Header row */
  :not(.dark-mode) table thead th {
    background: #FAFBFC !important;
    color: #6B7280 !important;
    font-size: 11px !important;
    font-weight: 600 !important;
    text-transform: uppercase !important;
    letter-spacing: 0.6px !important;
    padding: 9px 14px !important;
    border-bottom: 1.5px solid #E5E7EB !important;
    border-right: 1px solid #E5E7EB !important;
    white-space: nowrap !important;
    position: sticky !important;
    top: 0 !important;
    z-index: 2 !important;
  }
  :not(.dark-mode) table thead th:last-child { border-right: none !important; }

  /* Body cells */
  :not(.dark-mode) table tbody td {
    padding: 9px 14px !important;
    font-size: 13px !important;
    font-weight: 400 !important;
    color: #111827 !important;
    border-bottom: 1px solid #E5E7EB !important;
    border-right: 1px solid #E5E7EB !important;
    vertical-align: middle !important;
    background: #FFFFFF !important;
    line-height: 1.4 !important;
  }
  :not(.dark-mode) table tbody td:last-child { border-right: none !important; }

  /* Row hover */
  :not(.dark-mode) table tbody tr:hover td {
    background: #F9FAFB !important;
  }

  /* Footer cells */
  :not(.dark-mode) table tfoot td {
    padding: 9px 14px !important;
    font-size: 12px !important;
    font-weight: 600 !important;
    color: #374151 !important;
    border-top: 1.5px solid #E5E7EB !important;
    border-right: 1px solid #E5E7EB !important;
    background: #F9FAFB !important;
  }
  :not(.dark-mode) table tfoot td:last-child { border-right: none !important; }

  /* Table container */
  :not(.dark-mode) .blitz-table-wrap {
    border: 1px solid #E5E7EB !important;
    border-radius: 10px !important;
    overflow: hidden !important;
    background: #FFF !important;
  }

  /* Input cells inside tables — keep them clean */
  :not(.dark-mode) table tbody td input {
    border: 1px solid #E5E7EB !important;
    border-radius: 5px !important;
    padding: 4px 8px !important;
    font-size: 12px !important;
    font-family: 'JetBrains Mono', monospace !important;
    background: #FAFBFC !important;
    color: #111827 !important;
    outline: none !important;
    transition: border-color 0.15s !important;
  }
  :not(.dark-mode) table tbody td input:focus {
    border-color: #6366F1 !important;
    background: #FFF !important;
    box-shadow: 0 0 0 2px rgba(99,102,241,0.1) !important;
  }

  /* Number / mono values in cells */
  :not(.dark-mode) table tbody td[style*="JetBrains Mono"],
  :not(.dark-mode) table tbody td[style*="monospace"] {
    font-family: 'JetBrains Mono', monospace !important;
    font-size: 13px !important;
    font-weight: 600 !important;
    letter-spacing: -0.3px !important;
  }

  /* Positive / negative color overrides stay as-is (green/red) */
  /* Zebra stripe — very subtle */
  :not(.dark-mode) table tbody tr:nth-child(even) td {
    background: #FAFBFC !important;
  }
  :not(.dark-mode) table tbody tr:nth-child(even):hover td {
    background: #F3F4F6 !important;
  }
`;
